/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import {
    Configuration,
    ConfigurationParameters,
    InternalRatingsRequest,
    Ratings,
    RatingsApi,
} from 'client-code/internal-ratings';

import { APPLICATION_FEATURE_AREA } from '../../config';
import { CommonHeaders } from '../CommonHeaders';
import { Constants } from '../constants';
import { IInternalRatingsServiceRepository } from '../interfaces/IInternalRatingsServiceRepository';
import { Log } from '../logging/Log';
import { TServicesParams } from '../types';
import { UniqueIdentifier } from '../utils';

export class InternalRatingsServiceRepositoryImpl implements IInternalRatingsServiceRepository {
    private mParams: TServicesParams;

    private TAG: string = 'InternalRatingsServiceRepositoryImpl';

    public constructor(params: TServicesParams) {
        this.mParams = params;
    }

    public async fetchInternalRatingsFromService(): Promise<Ratings> {
        try {
            const commonHeaders = new CommonHeaders(APPLICATION_FEATURE_AREA.STARTUP).headers;

            const configurationParameters: ConfigurationParameters = {
                apiKey: this.mParams.accessToken,
                basePath: this.mParams.basePath,
                baseOptions: {
                    timeout: Constants.SERVICE_CONNECTION_TIMEOUT,
                    headers: commonHeaders,
                },
            };

            const requestParameters: InternalRatingsRequest = {
                applicationFeatureArea: commonHeaders.ApplicationFeatureArea,
                applicationName: commonHeaders.ApplicationName,
                applicationVersion: commonHeaders.ApplicationVersion,
                bodyId: this.mParams.bodyId,
                productName: commonHeaders.ProductName,
                msoPartnerId: this.mParams.msoPartnerId,
                deviceType: commonHeaders.DeviceType,
                xAmznRequestId: UniqueIdentifier.generateXAmznRequestId(),
                whiny: this.mParams.whiny || 'false',
            };

            const configuration = new Configuration(configurationParameters);
            const internalRatingsService = new RatingsApi(configuration);
            const internalRatingsServiceResponse =
                await internalRatingsService.internalRatings(requestParameters);

            return internalRatingsServiceResponse.data;
        } catch (error) {
            Log.e(this.TAG, 'fetchInternalRatings', error);
            throw error;
        }
    }
}
